import { motion } from "framer-motion";

import NftSlider from "./NftSlider";
import SellCard from "./SellCard";

import coin from "../../assets/images/coin.png";

import "./banner.css";

const Banner = () => {
  return (
    <div className="w-full"> {/* Ensure full width */}``
      <motion.section
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ ease: "easeInOut", duration: 0.9, delay: 0.2 }}
        className="flex flex-col md:flex-row items-center justify-between mt-12 mx-auto p-4 border-b dark:border-gray-700 border-gray-200">
        {/* Flex container for text and image */}
        <motion.h1
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            ease: "easeInOut",
            duration: 0.9,
            delay: 0.1,
          }}
          className="order-2 md:order-1 font-bold text-center md:text-left text-4xl md:text-4xl xl:text-5xl dark:text-white welcome-title w-full md:w-1/2 mt-8 md:mt-0"> {/* Text left */}
          Discover a World of Unique NFTs on Marketplace: 
          Your Premier Destination for Exclusive Digital Collectibles. Start Exploring and Trading Today!
        </motion.h1>

        <motion.div
          initial={{ opacity: 0, y: -180 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ ease: "easeInOut", duration: 0.9, delay: 0.2 }}
          className="order-1 md:order-2 md:flex md:items-center md:justify-end w-full md:w-1/2"> {/* Image right */}
          <img src={coin} alt="NFT Coin" className="coin mx-auto md:mx-0" /> {/* Centered in mobile, right in desktop */}
        </motion.div>
      </motion.section>
      <NftSlider />
      <SellCard />
    </div>
  );
};

export default Banner;
